import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Text, coreTheme } from "@kolmeo/ui-core";
export const PageHero = ({ header, children }) => {
    return (_jsxs(Box, { flexDirection: "column", borderBottomLeftRadius: 24, borderBottomRightRadius: 24, paddingX: 24, paddingTop: 24, backgroundColor: coreTheme.palette.taivasLighten10, children: [_jsx(Text, { variant: "headingH2", color: coreTheme.palette.persianBlue, children: header }), _jsx(Box, { marginTop: 0, marginBottom: 16, children: children })] }));
};
